import React, { useCallback, useContext, useEffect, useLayoutEffect, useRef, useState } from "react"
import { Button, Checkbox, Dimmer, Divider, Dropdown, DropdownItemProps, Header, Input, Label, Loader, Modal, Progress, Segment } from "semantic-ui-react";
import _ from 'lodash';
import $ from 'jquery';

import { TestingFileComponent } from "./TestingFile";
import { StatusMark } from "./StatusMark";
import "../../assets/scss/components/TestingDetails.scss";
import 'react-datepicker/dist/react-datepicker.min.css';
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import { hostAbsoluteUrl, hostUrl, restRequest, startLongTimeDownload } from "../../http";
import { MeasurementStatistics, OverviewSelections, TestingFile } from "../../models/testing_model";
import { PageData } from "../../models/common_model";
import { parseQueryObject, toUrlQueryString } from "../../utils";
import { TestingVisualSearchParameterContext } from "../../context";
import { IssueOverview } from "../../models/issue_overview_model";
import { useCurrentUser } from "../../hooks/auth-hook";
import { nextTick } from "process";
import { DropdownFilter, MultipleDropdownFilter } from "../commons/MyDropdown";
import { useModalControl } from "../../hooks/commonHooks";
import { BatchUpdateStatus } from "../BatchUpdateStatus";
import { dialogControl } from "../../controls/dialog-control";
import { LongTimeDownloader, useLongTimeDownload } from "../commons/LongTimeDownload";


const PAGE_SIZE = 100;

export function TestingDetails(props: { id: number, location: any }) {
    const { id } = props;

    const currentUser = useCurrentUser();

    const [searchParameters, setParentSearchParameter] = useContext(TestingVisualSearchParameterContext)!;

    const contextSummaryId = parseInt(_.get(searchParameters, 'in_summary_id', '0') || '0');

    const sidebarRef = useRef<HTMLDivElement>(null);
    const sFiles = useState<TestingFile[]>([]);
    const sMeasurementStatistics = useState<MeasurementStatistics[]>([]);
    const sPageNumber = useState(0);
    const sMaxPageNumber = useState(0);
    const sTotalNumber = useState(0);
    const sIsLoadingMore = useState(false);
    const sIsMeasurementStatisticsLoading = useState(false);
    const sidebarItemsRef = useRef<HTMLDivElement>(null);

    const [keyword, setKeyword] = useState<string>(_.get(searchParameters, 'serial_number', ''));
    const filterStatus = useState(_.get(searchParameters, 'status', '').split('_').map(s => parseInt(s)).filter(v => !_.isNil(v) && !_.isNaN(v)));
    const sCustomFilters = useState(_.get(searchParameters, 'custom_filter_ids', '').split('_').map(s => parseInt(s)).filter(v => !_.isNil(v) && !_.isNaN(v)));
    const filterUpdateStatus = useState(parseInt(_.get(searchParameters, 'update_status', '0')) || undefined);
    const sPassOnMessurement = useState<string[]>(_.get(searchParameters, 'pass_on_measurement_key', '').split('_-_').filter(v => !_.isEmpty(v)));
    const sFailOnMessurement = useState<string[]>(_.get(searchParameters, 'fail_on_measurement_key', '').split('_-_').filter(v => !_.isEmpty(v)));
    const sInvalidOnMessurement = useState<string[]>(_.get(searchParameters, 'invalid_on_measurement_key', '').split('_-_').filter(v => !_.isEmpty(v)));
    const sUnknownOnMessurement = useState<string[]>(_.get(searchParameters, 'unknown_on_measurement_key', '').split('_-_').filter(v => !_.isEmpty(v)));
    const sStation = useState<string[]>(_.get(searchParameters, 'testing_station_id', '').split('_-_').filter(v => !_.isEmpty(v)));
    const sEmployee = useState<string[]>(_.get(searchParameters, 'employee_id', '').split('_-_').filter(v => !_.isEmpty(v)));
    const start_time = _.get(searchParameters, 'start_time', '');
    const sStartTime = useState<Date>(start_time ? moment(start_time, 'YYYY-MM-DD HH:mm:ss').toDate() : null as any)
    const end_time = _.get(searchParameters, 'end_time', '');
    const sEndTime = useState<Date>(end_time ? moment(end_time, 'YYYY-MM-DD HH:mm:ss').toDate() : null as any)
    const sNeverPass = useState(parseInt(_.get(searchParameters, 'never_pass', '0')) || undefined)
    const sNeverPassOtherStation = useState(parseInt(_.get(searchParameters, 'never_pass_other_station', '0')) || undefined)
    const sStockIn = useState(parseInt(_.get(searchParameters, 'stock_in', '0')) || undefined);
    const sSerialMixedUp = useState(parseInt(_.get(searchParameters, 'serial_mix_up', '0')) || undefined);
    const sBySequence = useState(_.get(searchParameters, 'by_sequence', ''));
    const sHasFurbishment = useState(_.get(searchParameters, 'has_refurbishment_serial', '0') === '1');
    const sMPBatchSerial = useState<string[]>(_.get(searchParameters, 'mp_batch_serial', '').split('_-_').filter(v => !_.isEmpty(v)));
    const sIsBatchUploadingStatus = useState(false);

    const [selectedIndex, setSelectedIndex] = useState<number>(parseInt(_.get(searchParameters, 'selected_file_index', '0')));

    const [height, setHeight] = useState<number>();
    const sLoading = useState(false);

    const sSelectionsInfo = useState<OverviewSelections>();

    const batchUpdateStatusModal = useModalControl<number[]>([]);

    const jsonFileDownloader = useLongTimeDownload('testings/export_json_files/' + id, () => generateSearchParams(), 'post');
    const serialsDownloader = useLongTimeDownload('testings/export_serials/' + id, () => generateSearchParams(), 'post');

    const generateSearchParams = () => ({
        serial_number: keyword,
        status: filterStatus[0],
        custom_filter_ids: sCustomFilters[0],
        update_status: filterUpdateStatus[0],
        pass_on_measurement_key: sPassOnMessurement[0],
        fail_on_measurement_key: sFailOnMessurement[0],
        invalid_on_measurement_key: sInvalidOnMessurement[0],
        unknown_on_measurement_key: sUnknownOnMessurement[0],
        start_time: sStartTime[0] ? moment(sStartTime[0]).format('YYYY-MM-DD HH:mm:ss') : undefined,
        end_time: sEndTime[0] ? moment(sEndTime[0]).format('YYYY-MM-DD HH:mm:ss') : undefined,
        never_pass: sNeverPass[0],
        never_pass_other_station: sNeverPassOtherStation[0],
        stock_in: sStockIn[0],
        serial_mix_up: sSerialMixedUp[0],
        testing_station_id: sStation[0],
        employee_id: sEmployee[0],
        by_sequence: sBySequence[0],
        has_refurbishment_serial: sHasFurbishment[0],
        mp_batch_serial: sMPBatchSerial[0],
        page_size: PAGE_SIZE
    })

    const doRequestFiles = (pageNumber: number) => restRequest<PageData<TestingFile>>(`testings/files/${id}`, { ...generateSearchParams(), page_number: pageNumber }, 'post').then(data => {
        let items: TestingFile[];
        if (pageNumber === 1) {
            items = data.items;
        } else {
            items = [...sFiles[0], ...data.items];
        }
        sFiles[1](items);
        sPageNumber[1](pageNumber);
        sMaxPageNumber[1](data.pages);
        sTotalNumber[1](data.total);

        return items;
    })

    const updateMeasurementStatistics = () => {
        sIsMeasurementStatisticsLoading[1](true);
        return restRequest<MeasurementStatistics[]>(`testings/files_statistics/${id}`, generateSearchParams(), 'post').then(statics => {
            sMeasurementStatistics[1](statics);

            const measurementKeys = statics.map(s => s.key)
            sPassOnMessurement[1](mks => mks.filter(mk => measurementKeys.includes(mk)));
            sFailOnMessurement[1](mks => mks.filter(mk => measurementKeys.includes(mk)));
            sInvalidOnMessurement[1](mks => mks.filter(mk => measurementKeys.includes(mk)));
            sUnknownOnMessurement[1](mks => mks.filter(mk => measurementKeys.includes(mk)));
        }).finally(() => sIsMeasurementStatisticsLoading[1](false));
    }

    const batchUpdateStatus = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();

        sIsBatchUploadingStatus[1](true);

        restRequest<number[]>(`testings/file_ids/${id}`, { ...generateSearchParams() }, 'post').then(fileIds => {
            if (!fileIds || fileIds.length === 0) {
                dialogControl.alert('No sequences found!');
                return;
            }
            batchUpdateStatusModal.data = fileIds;
            batchUpdateStatusModal.setOpen(true);
        }).finally(() => sIsBatchUploadingStatus[1](false));
    }

    useEffect(() => {
        updateMeasurementStatistics();
    }, [filterStatus[0], filterUpdateStatus[0], sStartTime[0], sEndTime[0], sNeverPass[0], sNeverPassOtherStation[0], sStockIn[0], sSerialMixedUp[0], sBySequence[0], sHasFurbishment[0], sStation[0], sEmployee[0], sMPBatchSerial[0], sCustomFilters[0], sPassOnMessurement[0].join(','), sFailOnMessurement[0].join(','), sInvalidOnMessurement[0].join(','), sUnknownOnMessurement[0].join(',')])

    useEffect(() => {
        sLoading[1](true);
        Promise.all([restRequest<OverviewSelections>(`testings/overview_selections/${id}`).then(info => {
            sSelectionsInfo[1](info);
            sStation[1](s => s.filter(v => info.station_ids.includes(v)));
            sEmployee[1](e => e.filter(v => info.employees.includes(v)));
            sNeverPassOtherStation[1](nps => info.stations_in_same_order.find(s => s.id === nps) ? nps : NaN);
            sMPBatchSerial[1](mpbs => mpbs.filter(v => info.mp_batch_serials.find(mpb => mpb.uuid === v)));
            sCustomFilters[1](fs => fs.filter(v => info.data_filters.filter(df => df.id === v)));
        })]).then(() => {
            return doRequestFiles(1);
        }).finally(() => {
            sLoading[1](false);
        })
    }, [id])

    useEffect(() => {
        if (id == sNeverPassOtherStation[0]) {
            sNeverPassOtherStation[1](-1);
        }
    }, [id, sNeverPassOtherStation[0]]);

    useEffect(() => {
        const onRemove = function (e: any, summaryId: number, fileId: number) {
            if (summaryId === contextSummaryId) {
                sIsLoadingMore[1](true);
                Promise.all([doRequestFiles(sPageNumber[0]), updateMeasurementStatistics()]).finally(() => {
                    sIsLoadingMore[1](false);
                });
            }
        }
        $(document.body).on('remove_json_file_from_summary' as any, onRemove);

        return () => {
            $(document.body).off('remove_json_file_from_summary' as any, onRemove);
        }

    }, [contextSummaryId]);

    useEffect(() => {
        if (selectedIndex >= 0) {
            setTimeout(() => {
                if (sidebarItemsRef.current) {
                    const activeItem = sidebarItemsRef.current.querySelector('.active') as HTMLDivElement;
                    if (activeItem) {
                        const itemY = activeItem.offsetHeight * selectedIndex;
                        if (itemY < sidebarItemsRef.current.scrollTop) {
                            sidebarItemsRef.current.scrollTop = itemY;
                        }

                        if (itemY > sidebarItemsRef.current.scrollTop + sidebarItemsRef.current.offsetHeight) {
                            sidebarItemsRef.current.scrollTop = itemY;
                        }
                    }
                }
            }, 100);
        }
    }, [selectedIndex])

    useLayoutEffect(() => {
        const onResize = () => {
            const $sidebarRef = $(sidebarRef.current!);
            if ($sidebarRef.length > 0) {
                const padding = parseInt(window.getComputedStyle($sidebarRef.parent().parent()[0], null).getPropertyValue('padding-top'));
                setHeight(window.innerHeight - $sidebarRef.offset()!.top - padding * 2 - 2);
            }
        }

        window.addEventListener('resize', onResize);

        onResize();

        return () => {
            window.removeEventListener('resize', onResize);
        }
    }, []);

    useEffect(() => {
        const sidebarObj = sidebarItemsRef.current as any;
        sidebarItemsRef.current!.onscroll = e => {
            if (sidebarObj.isLoading) {
                return;
            }
            sidebarObj.isLoading = true;
            const threshold = sidebarItemsRef.current!.scrollHeight - sidebarItemsRef.current!.scrollTop - sidebarItemsRef.current!.offsetHeight;
            if (threshold < 250) {
                if (sMaxPageNumber[0] > sPageNumber[0]) {
                    sIsLoadingMore[1](true);
                    doRequestFiles(sPageNumber[0] + 1).finally(() => {
                        sIsLoadingMore[1](false);
                        sidebarObj.isLoading = false;
                    });
                } else {
                    sidebarObj.isLoading = false;
                }
            } else {
                sidebarObj.isLoading = false;
            }
        }

    }, [sMaxPageNumber[0], sPageNumber[0]]);

    const onScrollSelected = useCallback((direction: number) => {
        if (sFiles[0] && sFiles[0].length > 0) {
            let currentIndex = selectedIndex
            if (currentIndex !== -1) {
                currentIndex += direction;

                if (currentIndex === -1) {
                    currentIndex = sFiles[0].length - 1;
                } else if (currentIndex >= sFiles[0].length) {
                    currentIndex = 0
                }

                setSelectedIndex(currentIndex)
            }
        }
    }, [sFiles[0], selectedIndex])

    useEffect(() => {
        /*
        arrow left：37
        arrow up：38
        arrow right：39
        arrow down：40
        */
        const onKey = (e: JQuery.KeyDownEvent) => {
            if (e.keyCode == 38) {
                e.preventDefault();
                e.stopPropagation();
                // arrow up
                onScrollSelected(-1);
            } else if (e.keyCode == 40) {
                e.preventDefault();
                e.stopPropagation();
                // arrow down
                onScrollSelected(1);
            }
        }

        $(document).on('keydown', onKey);

        return () => {
            $(document).off('keydown', onKey);
        }
    }, [sFiles[0], selectedIndex]);

    useEffect(() => {
        setParentSearchParameter((ps: any) => ({...ps, selected_file_index: selectedIndex}));
    }, [selectedIndex]);

    const updateParentParameters = () => {
        const params: any = { serial_number: keyword, status: filterStatus[0].join('_'), update_status: filterUpdateStatus[0] || undefined, custom_filter_ids: sCustomFilters[0].join('_'), testing_station_id: sStation[0].join('_-_'), employee_id: sEmployee[0].join('_-_'), never_pass: sNeverPass[0] || null, never_pass_other_station: sNeverPassOtherStation[0] || null, stock_in: sStockIn[0] || null, serial_mix_up: sSerialMixedUp[0] || null, mp_batch_serial: sMPBatchSerial[0].join('_-_') };
        params['start_time'] = sStartTime[0] ? moment(sStartTime[0]).format('YYYY-MM-DD HH:mm:ss') : null;
        params['end_time'] = sEndTime[0] ? moment(sEndTime[0]).format('YYYY-MM-DD HH:mm:ss') : null;
        
        params['by_sequence'] = sBySequence[0] || '';
        params['has_refurbishment_serial'] = sHasFurbishment[0] ? '1' : undefined;

        params.pass_on_measurement_key = sPassOnMessurement[0].filter(v => !_.isEmpty(v)).join('_-_');
        params.fail_on_measurement_key = sFailOnMessurement[0].filter(v => !_.isEmpty(v)).join('_-_');
        params.invalid_on_measurement_key = sInvalidOnMessurement[0].filter(v => !_.isEmpty(v)).join('_-_');
        params.unknown_on_measurement_key = sUnknownOnMessurement[0].filter(v => !_.isEmpty(v)).join('_-_');

        setParentSearchParameter((ps: any) => ({...ps, ...params}));
    }

    const filterStatuses: DropdownItemProps[] = [
        { text: 'Pass', value: 1, key: 1 },
        { text: 'Fail', value: 2, key: 2 },
        { text: 'Invalid', value: 3, key: 3 },
        { text: 'Stopped', value: 4, key: 4 },
    ]

    const filterUpdateStatuses: DropdownItemProps[] = [
        { text: '', value: undefined, key: undefined },
        { text: 'Pass', value: 1, key: 1 },
        { text: 'Fail', value: 2, key: 2 },
    ]

    const filtersSations: DropdownItemProps[] = sSelectionsInfo[0]?.station_ids.sort().map(s => ({
        text: s,
        value: s,
        key: s
    })) || []

    const filtersEmployees: DropdownItemProps[] = sSelectionsInfo[0]?.employees.sort().map(s => ({
        text: s,
        value: s,
        key: s
    })) || []

    const filterYesNo: DropdownItemProps[] = [
        { text: '', value: undefined, key: undefined },
        { text: 'Yes', value: 1, key: 1 },
        { text: 'No', value: 2, key: 2 },
    ]

    const filtersSationInSameOrder: DropdownItemProps[] = [{ text: '', value: undefined, key: undefined } as any].concat(sSelectionsInfo[0]?.stations_in_same_order.sort().map(s => ({
        text: s.name,
        value: s.id,
        key: s.id
    })) || [])

    const filtersMPBatchSerials: DropdownItemProps[] = sSelectionsInfo[0]?.mp_batch_serials.map(s => ({
        text: s.serial,
        content: <Header size="small">{s.serial} <Header.Subheader>{s.start.split('T')[0]}~{s.end.split('T')[0]}</Header.Subheader></Header>,
        value: s.uuid,
        key: s.uuid
    })) || [];

    const customFilterOptions: DropdownItemProps[] = sSelectionsInfo[0]?.data_filters.sort().map(v => ({
        text: v.name,
        value: v.id,
        key: v.id,
        title: v.description || ''
    })) || []

    const passMeasurementOptions = generateMeasurementDropdownOptions(sMeasurementStatistics[0], 'pass_count')
    const failMeasurementOptions = generateMeasurementDropdownOptions(sMeasurementStatistics[0], 'fail_count')
    const invalidMeasurementOptions = generateMeasurementDropdownOptions(sMeasurementStatistics[0], 'invalid_count')
    const unknownMeasurementOptions = generateMeasurementDropdownOptions(sMeasurementStatistics[0], 'unknown_count')

    const selected = selectedIndex >= 0 ? sFiles[0][selectedIndex] : null;

    return <Segment loading={sLoading[0]} style={{ margin: 0 }}>
        <div style={{ position: 'relative' }}>
            <div className={`searchBar`}>
                <div className="resultCount_detail"><b>{sTotalNumber[0]}</b>Results</div>
                <form className="clearfix" onSubmit={e => {
                    e.preventDefault();

                    sLoading[1](true);
                    doRequestFiles(1)
                        .then(items => {
                            sidebarItemsRef.current!.scrollTop = 0;
                            if (items.length > 0) {
                                setSelectedIndex(0)
                            } else {
                                setSelectedIndex(-1)
                            }
                        })
                        .finally(() => sLoading[1](false));

                    updateParentParameters();
                }}>
                    <Input size="mini" placeholder="Serials or File Name" value={keyword} onChange={(_, d) => setKeyword(d.value.trim())}></Input>
                    <div className="ui mini input date" style={{ alignItems: 'center' }}>
                        <ReactDatePicker showTimeSelect
                            dateFormat="yyyy-MM-d HH:mm"
                            timeFormat="HH:mm"
                            selected={sStartTime[0]} onChange={(ds: Date) => sStartTime[1](ds)}></ReactDatePicker>
                        <div style={{ padding: '0 0.5rem' }}> - </div>
                        <ReactDatePicker showTimeSelect
                            dateFormat="yyyy-MM-d HH:mm"
                            timeFormat="HH:mm"
                            minDate={sStartTime[0]}
                            selected={sEndTime[0]} onChange={(ds: Date) => sEndTime[1](ds)}></ReactDatePicker>
                    </div>
                
                    {filtersMPBatchSerials.length > 1 && <MultipleDropdownFilter label="Batch" value={sMPBatchSerial[0]} onChange={sMPBatchSerial[1]} options={filtersMPBatchSerials} scrolling search/>}
                    
                    {!_.isEmpty(customFilterOptions) && <MultipleDropdownFilter label="Custom Filters" value={sCustomFilters[0]} onChange={sCustomFilters[1]} options={customFilterOptions} scrolling search/>}

                    <MultipleDropdownFilter label="Status" search value={filterStatus[0]} onChange={filterStatus[1]} options={filterStatuses} />

                    <DropdownFilter label="Update Status" value={filterUpdateStatus[0]} onChange={filterUpdateStatus[1]} options={filterUpdateStatuses} />

                    <MultipleDropdownFilter label="Pass On" value={sPassOnMessurement[0]} onChange={sPassOnMessurement[1]} options={passMeasurementOptions} loading={sIsMeasurementStatisticsLoading[0]}
                        search={(options, str) => options.filter(o => (o.value as string + '           ' + o.text).toUpperCase().includes(str.toUpperCase()))}
                    />
                    
                    <MultipleDropdownFilter label="Fail On" value={sFailOnMessurement[0]} onChange={sFailOnMessurement[1]} options={failMeasurementOptions} loading={sIsMeasurementStatisticsLoading[0]}
                        search={(options, str) => options.filter(o => (o.value as string + '           ' + o.text).toUpperCase().includes(str.toUpperCase()))}
                    />
                    
                    <MultipleDropdownFilter label="Invalid On" value={sInvalidOnMessurement[0]} onChange={sInvalidOnMessurement[1]} options={invalidMeasurementOptions} loading={sIsMeasurementStatisticsLoading[0]}
                            search={(options, str) => options.filter(o => (o.value as string + '           ' + o.text).toUpperCase().includes(str.toUpperCase()))}
                        />

                    <MultipleDropdownFilter label="Skip On" value={sUnknownOnMessurement[0]} onChange={sUnknownOnMessurement[1]} options={unknownMeasurementOptions} loading={sIsMeasurementStatisticsLoading[0]}
                        search={(options, str) => options.filter(o => (o.value as string + '           ' + o.text).toUpperCase().includes(str.toUpperCase()))}
                    />

                    <DropdownFilter label="Never Pass Current Station" value={sNeverPass[0]} onChange={sNeverPass[1]} options={filterYesNo} />
                    
                    <DropdownFilter label="Never Pass Other Station" value={sNeverPassOtherStation[0]} onChange={sNeverPassOtherStation[1]} options={filtersSationInSameOrder} />

                    <DropdownFilter label="Stock In" value={sStockIn[0]} onChange={sStockIn[1]} options={filterYesNo} />

                    <MultipleDropdownFilter label="Station" value={sStation[0]} onChange={sStation[1]} options={filtersSations} />

                    <MultipleDropdownFilter label="Operator" value={sEmployee[0]} onChange={sEmployee[1]} options={filtersEmployees} search scrolling/>

                    <DropdownFilter label="Serial Mix-up" value={sSerialMixedUp[0]} onChange={sSerialMixedUp[1]} options={filterYesNo} />

                    <DropdownFilter<string> label="By Sequence" value={sBySequence[0] || undefined} onChange={sBySequence[1]} options={['', 'only_first', 'only_last'].map(v => ({text: v.replaceAll('_', ' '), value: v || undefined, key: v}))} />

                    <Button content="Has Refurbishment" icon="check" size="mini" as="a" color={sHasFurbishment[0] ? 'yellow' : undefined} onClick={(e,d) => sHasFurbishment[1](v => !v)} className="form-item" />

                    <Button primary size="mini" type="submit" className="form-item">Search</Button>

                    <Dropdown text="Export" button className="mini olive">
                        <Dropdown.Menu>
                            <Dropdown.Item text="Serials CSV" onClick={() => {
                                serialsDownloader.start();
                            }} />
                            <Dropdown.Divider />
                            <Dropdown.Item text='File Names CSV' onClick={() => {
                                window.open(hostAbsoluteUrl('testings/export_json_file_names/' + id + '?no_cache=' + Date.now() + '&searchData=' + toUrlQueryString(generateSearchParams())))
                            }} />
                            <Dropdown.Item text='JSON Files' onClick={() => {
                                jsonFileDownloader.start();
                            }} />
                            <Dropdown.Item text='Batchs' onClick={() => {
                                window.open(hostAbsoluteUrl(`testings/export_batch/${id}?no_cache=${Date.now()}`))
                            }} />
                        </Dropdown.Menu>
                    </Dropdown>

                    {currentUser.permissions.analyzed_unit.create && <Button loading={sIsBatchUploadingStatus[0]} onClick={batchUpdateStatus} as="a" size="mini" className="form-item olive">Batch Update Status</Button>}

                </form>
            </div>
            <Divider />
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', height: height ? (height + 'px') : 'auto' }}>
            <div style={{ width: "200px", height: '100%', flex: 'none', display: 'flex', flexDirection: 'column', padding: '0.5rem' }} ref={sidebarRef}>
                <div ref={sidebarItemsRef} className="ui vertical menu" style={{ flex: '1', height: '100%', width: '100%', margin: '0px', overflow: 'auto' }}>
                    {sFiles[0].map((sn, i) => <div onClick={e => setSelectedIndex(i)} className={`ui side-bar-item item ${selected?.id === sn.id ? 'active' : ''}`} key={sn.id}>{sn.serial_number} <StatusMark sortName status={sn.update_status !== 0 ? sn.update_status : sn.status}></StatusMark></div>)}
                </div>
                <div style={{ position: 'absolute', left: '-12px', top: '8rem', opacity: 0.618 }}>
                    <Button icon="arrow up" size="mini" onClick={e => onScrollSelected(-1)}></Button>
                    <Button icon="arrow down" size="mini" onClick={e => onScrollSelected(1)} style={{ display: 'block', marginTop: '2px', marginBottom: '2px' }}></Button>
                </div>
                <div style={{ position: 'absolute', left: '90px', bottom: '2.5rem', opacity: 0.618, display: sIsLoadingMore[0] ? 'inherit' : 'none' }}>
                    <Dimmer active inverted>
                        <Loader inverted></Loader>
                    </Dimmer>
                </div>
            </div>
            <div style={{ flex: '1' }}>
                {
                    selected && <TestingFileComponent file={selected} height={height || 0} onFileChange={updateFile => {
                        sFiles[1](fs => fs.map(f => f.id === updateFile.id ? updateFile : f));
                    }}></TestingFileComponent>
                }
            </div>
        </div>

        <BatchUpdateStatus resultId={id} modalControl={batchUpdateStatusModal} onFinish={() => { 
            batchUpdateStatusModal.setOpen(false);
        }}></BatchUpdateStatus>

        <LongTimeDownloader {...jsonFileDownloader}/>
        <LongTimeDownloader {...serialsDownloader}/>
    </Segment>
}


function generateMeasurementDropdownOptions(measurementStatistics: MeasurementStatistics[], numberKey: keyof (MeasurementStatistics)): DropdownItemProps[] {
    const measurementOptions: DropdownItemProps[] = measurementStatistics.sort((a, b) => {
        const av = a[numberKey] as number || 0;
        const bv = b[numberKey] as number || 0;

        if (av > bv) {
            return -1
        } else if (av === bv) {
            return 0
        } else {
            return 1;
        }
    }).map(ms => {
        return {
            name: ms.name,
            text: ms.name,
            content: <>{ms.name} &nbsp;&nbsp;<Label color="orange" size="mini" circular title={ms.export_file_name}>{ms[numberKey] || 0}</Label></>,
            value: `${ms.key}`,
            key: `${ms.key}`,
            pass_count: ms.pass_count,
            fail_count: ms.fail_count,
            invalid_count: ms.invalid_count,
            unknown_count: ms.unknown_count
        }
    });

    return measurementOptions;
}